module.exports = __webpack_public_path__ + "img/sarahbash.612e3d2.png";